import { ViewVariant } from '@cp/shared/modal';
import { StepName } from '../model';
import {
  ClientRegistrationStepProps,
  StepAcquaintance,
  StepAfterAll,
  StepCareer,
  StepClientType,
  StepEmpty,
  StepLocation,
  StepWelcome,
} from './steps';

export const stepToComponent: Readonly<Record<StepName, (props: ClientRegistrationStepProps) => JSX.Element | null>> = {
  [StepName.ClientType]: StepClientType,
  [StepName.MainCareer]: StepCareer,
  [StepName.Location]: StepLocation,
  [StepName.Acquaintance]: StepAcquaintance,
  [StepName.Welcome]: StepWelcome,
  [StepName.AfterAll]: StepAfterAll,
  [StepName.Tariff]: StepEmpty,
  [StepName.Initial]: StepEmpty,
};

export const stepToLayout = {
  [StepName.Welcome]: { fullscreen: true, mobile: ViewVariant.Fullscreen },
  [StepName.Acquaintance]: { fullscreen: true, mobile: ViewVariant.Fullscreen },
  [StepName.AfterAll]: { fullscreen: true, mobile: ViewVariant.Fullscreen },
};
